import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { EditorContentStateProps } from '../src/EditorContentState/types.ts';

export const EditorContentStateComponent: LoadableType<Omit<EditorContentStateProps, 'flags'>> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-EditorContentStateEditorContentStateComponent" */ '../src/EditorContentState/EditorContentStateComponent.tsx'
				)
			).EditorContentStateComponent,
	});
